import React, { useState, useEffect } from "react";
import { Typography, Grid, Box, Modal, Button } from "@mui/material";
import { User, UsersThree, Gear } from "phosphor-react";
import GearPlusIcon from "../../../ReusableComponents/Svgs/GearPlusIcon";
import GearArrowIcon from "../../../ReusableComponents/Svgs/GearArrowIcon";
import AdminUserIcon from "../../../ReusableComponents/Svgs/AdminUserIcon";
import OwnersSvg from "../../../ReusableComponents/Svgs/OwnersSvg";
import DeleteModal from "../../../ReusableComponents/DeleteModal/DeleteModal";
import ReplaceAndTransferModal from "../../OrganizationsModals/ReplaceAndTransferModal/ReplaceAndTransferModal";
import OrgNameChangeModal from "../../OrganizationsModals/OrgNameChangeModal/OrgNameChangeModal";
import CommonLoader from "../../../ReusableComponents/CommonLoader/CommonLoader";
import useStyles from "../NewOrganizationsOverview/NewOrganizationsOverview.styles";
import { fdelete, fget, fpatch } from "../../../../API/callsApi";
import OrganizationActionsModals from "../../OrganizationsModals/OrganizationActionModal/OrganizationActionsModals";
import useAuth from "../../../../hooks/useAuth";
import toast from "react-hot-toast";

const ManageOrganizations = ({ currentOrganization }) => {
  const classes = useStyles();
  const { getOrgList, userData } = useAuth();
  const [isLeaveOrgModalOpen, setLeaveOrgModalOpen] = useState(false);
  const [isDeleteOrgModalOpen, setDeleteOrgModalopen] = useState(false);
  const [isTransferModalOpen, setTransferModalOpen] = useState(false);
  const [isOrgChangeModalOpen, setOrgChangeModalOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [currentOrgInfo, setCurrentOrgInfo] = useState({});
  const [orgActionModalOpen, setOrgActionModalOpen] = useState(false);
  const [isRemoving, setIsRemovingUser] = useState(false);

  const handleOrgActionModal = () => {
    setOrgActionModalOpen(!orgActionModalOpen);
  };

  const handleLeaveOrgModal = () => {
    setLeaveOrgModalOpen(!isLeaveOrgModalOpen);
  };

  const handleDeleteOrgModal = () => {
    setDeleteOrgModalopen(!isDeleteOrgModalOpen);
  };

  const handleTransferModal = () => {
    setTransferModalOpen(!isTransferModalOpen);
  };

  const handleOrgChangeModal = () => {
    setOrgChangeModalOpen(!isOrgChangeModalOpen);
  };

  const getOrg = async () => {
    if (currentOrganization) {
      setLoading(true);
      let userData = {
        url: `/user/org/${currentOrganization}/`,
      };
      try {
        const res = await fget(userData);
        if (res?.status === 200 || res.status === 201) {
          setCurrentOrgInfo(res.data);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };

  const removeConnectionAndUser = async () => {
    setIsRemovingUser(true);
    const url = `/organization/${currentOrgInfo.id}/user/${userData.id}/remove/`;
    try {
      const res = await fpatch({ url });
      if (res.status === 200 || res.status === 201) {
        handleLeaveOrgModal();
        handleOrgActionModal();
        getOrgList();
        history.push("/dashboard/?dashboardType=organizations");
        setIsRemovingUser(false);
      }
    } catch (error) {
      toast.error("Some error occured");
      setIsRemovingUser(false);
    }
  };

  const deleteOrg = async () => {
    setIsRemovingUser(true);
    try {
      const res = await fdelete({
        url: `/organization/${currentOrgInfo.id}/`,
      });
      console.log(res);
      setIsRemovingUser(false);
    } catch (error) {
      toast.error("Some error occured");
      setIsRemovingUser(false);
    }
  };

  useEffect(() => {
    getOrg();
  }, [currentOrganization]);

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h2" fontWeight={600}>
          Organization Info
        </Typography>
        <Button onClick={handleOrgActionModal}>
          <Gear weight="fill" size={30} color="#000000" />
        </Button>
      </div>
      {!isLoading && (
        <Box
          mt={2}
          style={{ border: "1px solid #BBBBBB", borderRadius: "10px" }}
        >
          <Grid container spacing={2} p={2}>
            <Grid item xs={2}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <GearPlusIcon />
                  <Typography variant="h4" fontWeight="600">
                    {currentOrgInfo.service_count}
                  </Typography>
                </div>
                <Typography variant="h4">Total Services</Typography>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <GearArrowIcon />
                  <Typography variant="h4" fontWeight="600">
                    {currentOrgInfo.active_services}
                  </Typography>
                </div>
                <Typography variant="h4">Active Services</Typography>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <UsersThree size={35} />
                  <Typography variant="h4" fontWeight="600">
                    {currentOrgInfo.user_count}
                  </Typography>
                </div>
                <Typography variant="h4">Total Users</Typography>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <AdminUserIcon />
                  <Typography variant="h4" fontWeight="600">
                    {currentOrgInfo.admin_count}
                  </Typography>
                </div>
                <Typography variant="h4">Admin Users</Typography>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <User size={35} />
                  <Typography variant="h4" fontWeight="600">
                    {currentOrgInfo.user_count - currentOrgInfo.admin_count}
                  </Typography>
                </div>
                <Typography variant="h4">Regular Users</Typography>
              </div>
            </Grid>
          </Grid>
        </Box>
      )}

      {isLoading ? (
        <div className={classes.loaderContainer}>
          <CommonLoader />
        </div>
      ) : (
        <Grid container mt={3}>
          <Grid item xs={5}>
            <Grid container>
              <Grid item xs={4}>
                <Typography variant="h5" style={{ color: "#666666" }}>
                  Org Owner
                </Typography>
              </Grid>
              <Grid item xs={1}>
                :
              </Grid>
              <Grid item xs={7}>
                <Typography variant="h5">
                  {currentOrgInfo.owner?.first_name}{" "}
                  {currentOrgInfo.owner?.last_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={1}>
              <Grid item xs={4}>
                <Typography variant="h5" style={{ color: "#666666" }}>
                  Created by
                </Typography>
              </Grid>
              <Grid item xs={1}>
                :
              </Grid>
              <Grid item xs={7}>
                <Typography variant="h5">
                  {currentOrgInfo.created_by?.first_name}{" "}
                  {currentOrgInfo.created_by?.last_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={1}>
              <Grid item xs={4}>
                <Typography variant="h5" style={{ color: "#666666" }}>
                  Created on
                </Typography>
              </Grid>
              <Grid item xs={1}>
                :
              </Grid>
              <Grid item xs={7}>
                <Typography variant="h5">
                  {new Date(currentOrgInfo.joining_date).toLocaleDateString(
                    "en-US",
                    {
                      month: "numeric",
                      day: "numeric",
                      year: "numeric",
                    }
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <Grid container>
              <Grid item xs={4}>
                <Typography variant="h5" style={{ color: "#666666" }}>
                  User Role
                </Typography>
              </Grid>
              <Grid item xs={1}>
                :
              </Grid>
              <Grid item xs={7} display="flex" alignItems="center" gap={1}>
                {currentOrgInfo.role === "user" && <User />}
                <Typography variant="h5">
                  {currentOrgInfo.role &&
                    currentOrgInfo.role?.slice(0, 1)?.toUpperCase()}
                  {currentOrgInfo.role?.slice(1)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={4}
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            {/* <div style={{ width: "220px" }}>
              <OutlinedButton
                text="Request Name Change"
                submit={handleOrgChangeModal}
              />
            </div>
            <div style={{ width: "220px", margin: "12px 0px" }}>
              {currentOrgInfo.role === "owner" && (
                <OutlinedButton
                  text="Transfer Ownership"
                  icon={<OwnersSvg />}
                  submit={handleTransferModal}
                />
              )}
            </div>
            <div style={{ width: "220px" }}>
              <RedFilledButton
                text="Delete Org"
                icon={<Trash color="#FFFFFF" />}
                submit={handleDeleteOrgModal}
              />
            </div> */}
          </Grid>
        </Grid>
      )}
      <Modal
        open={isLeaveOrgModalOpen}
        className={classes.centerContainer}
        onClose={handleLeaveOrgModal}
      >
        <DeleteModal
          leave={true}
          handleDelete={removeConnectionAndUser}
          closeModal={handleLeaveOrgModal}
          text1="Are you sure you want to leave the following organization?"
          text2={currentOrgInfo.name}
          btnText="Leave Organization"
          isRemoving={isRemoving}
        />
      </Modal>
      <Modal
        open={isDeleteOrgModalOpen}
        className={classes.centerContainer}
        onClose={handleDeleteOrgModal}
      >
        <DeleteModal
          removeOrg={true}
          handleDelete={deleteOrg}
          closeModal={handleDeleteOrgModal}
          text1="Are you sure you want to delete the following organization?"
          text2={currentOrgInfo.name}
          btnText="Delete Organization"
          isRemoving={isRemoving}
        />
      </Modal>
      <Modal
        open={isTransferModalOpen}
        className={classes.centerContainer}
        onClose={handleTransferModal}
      >
        <ReplaceAndTransferModal
          icon={<OwnersSvg />}
          header="Transfer Ownership"
          closeModal={handleTransferModal}
          getOrg={getOrg}
          orgInfo={currentOrgInfo}
          handleOrgActionModal={handleOrgActionModal}
        />
      </Modal>
      <Modal
        open={isOrgChangeModalOpen}
        className={classes.centerContainer}
        onClose={handleOrgChangeModal}
      >
        <OrgNameChangeModal
          orgInfo={currentOrgInfo}
          close={handleOrgChangeModal}
          getOrg={getOrg}
          handleOrgActionModal={handleOrgActionModal}
        />
      </Modal>
      <Modal
        open={orgActionModalOpen}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClose={handleOrgActionModal}
      >
        <OrganizationActionsModals
          name={currentOrgInfo.name}
          close={handleOrgActionModal}
          view={currentOrgInfo.role}
          openLeaveOrgModal={handleLeaveOrgModal}
          openOrgNameChangeModal={handleOrgChangeModal}
          openTransferOwnerModal={handleTransferModal}
          openDeleteOrgModal={handleDeleteOrgModal}
        />
      </Modal>
    </div>
  );
};

export default ManageOrganizations;
